<mat-form-field [formGroup]="selectForm">
  @if (fieldNames[0].startsWith('<Not')) {
    <div>
      <mat-select
        placeholder="Select column"
        (selectionChange)="addSelectedValue($event)"
        [formControlName]="fieldName"
      >
        @for (name of fieldNames; track $index) {
          <mat-option
            [value]="{
              name,
              columnId,
              missingAllowed,
              validateDate,
              validateCode,
              validCodes,
              systemColumnName,
            }"
            [disabled]="checkSelected(name, columnId)"
          >
            {{ name }}
          </mat-option>
        }
      </mat-select>
    </div>
  } @else {
    <!-- auto-mapped values don't need placeholder, checkSelected or addSelectedValue -->
    <mat-select [formControlName]="fieldName" [(value)]="fieldValue">
      <mat-option [value]="fieldValue">
        {{ systemColumnName }}
      </mat-option>
    </mat-select>
  }
  @if (
    selectForm.controls[fieldName].errors?.required &&
    selectForm.controls[fieldName].touched
  ) {
    <mat-error>You must select a column</mat-error>
  }
</mat-form-field>
